var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"symbols pb-2"},[(_vm.game.name == 'Dice')?_c('dice',{attrs:{"game-id":_vm.gameId,"selected-items":_vm.selectedItems},on:{"select":_vm.selectItem}}):_c('basic',{attrs:{"game-name":_vm.game.name,"game-id":_vm.gameId,"selected-items":_vm.selectedItems},on:{"select":_vm.selectItem}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }